// Try avoid long words

export type JobItem = {
  logo: string;
  title?: string;
  company?: string;
  startDate?: string;
  endDate?: string;
  url?: string;
};

const jobs: JobItem[] = [
  {
    logo: 'img:mail.jpg',
    title: 'Data Engineer',
    company: 'Marketing Artificial Intelligence Lab',
    startDate: 'Nov 2017',
    endDate: 'May 2019',
    url: 'https://www.linkedin.com/company/marketing-ai-lab/',
  },
  {
    logo: 'img:unsw-business.jpg',
    title: 'Course Tutor & Admin',
    company: 'UNSW Business School',
    startDate: 'Nov 2018',
    endDate: 'May 2019',
    url: 'https://www.business.unsw.edu.au/',
  },
  {
    logo: 'img:unsw.jpg',
    title: 'Research Assistant',
    company: 'UNSW Mining Engineering',
    startDate: 'Aug 2019',
    endDate: 'Dec 2019',
    url: 'https://www.engineering.unsw.edu.au/unsw-mining-engineering',
  },
  {
    logo: 'img:unsw.jpg',
    title: 'Web Developer',
    company: 'UNSW',
    startDate: 'Jan 2019',
    endDate: 'Aug 2020',
    url: 'https://www.education.unsw.edu.au/pvce',
  },
  {
    logo: 'img:canva.jpg',
    title: 'Frontend Engineer',
    company: 'Canva',
    startDate: 'Jan 2021',
    endDate: 'TBA',
    url: 'https://about.canva.com/',
  },
];

export default jobs;
